<template>
  <div
    class="slide-section-main repeat-inner"
    :class="{
      'remove-top': currentRoute === 'AppointmentDetail'
    }"
    style="display: block;"
  >
    <header-vue :my-return="myReturn" :long-title="true" title="Repeat" />
    <div class="slide-section-area-wrapper">
      <div class="slide-section-inner-wrapper">
        <!-- All options -->
        <ul class="check-list">
          <li
            v-for="(options, index) in optionsOrder"
            :key="index"
            :class="{
              active:
                options.index === selectedIndex &&
                innerOrOuter === options.innerOrOuter
            }"
            @click="optionSelected(options.innerOrOuter, options.index)"
          >
            <span>
              <object
                class="svg-back-arrow"
                :data="checkSvg"
                type="image/svg+xml"
              ></object>
            </span>
            <span class="inner-option">
              {{
                options.innerOrOuter === "inner"
                  ? innerOptions[options.index]
                  : outerOptions[options.index]
              }}

              <!-- Inner option -->
              <repeat-inner
                v-if="
                  options.index === selectedIndex &&
                    innerOrOuter === options.innerOrOuter &&
                    !(options.index === 0 && options.innerOrOuter === 'outer')
                "
                :done="done"
                :required-custom-input="innerOrOuter === 'inner'"
                :required-month-select="
                  options.innerOrOuter === 'inner' && options.index === 2
                "
                :required-week-select="
                  options.innerOrOuter === 'inner' && options.index === 1
                "
              />
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderVue from "./common/Header.vue";
import RepeatInner from "./RepeatInner";
import { mapGetters, mapMutations } from "vuex";
import { providerDependentMixin } from "../../../../mixins/providerDependentMixin";

export default {
  mixins: [providerDependentMixin],
  props: {
    done: Function,
    displayOption: Function
  },
  data() {
    return {
      backSvg: require("../../../../assets/svg/back.svg"),
      rightArrow: require("../../../../assets/svg/right-arrow.svg"),
      checkSvg: require("../../../../assets/svg/check-mark.svg")
    };
  },
  computed: {
    ...mapGetters({
      getRepeat: "getRepeat", // Get repeat information
      getAppDate: "getDate", // Getting the date on which the appointment is set
      getEdit: "getEdit", // Getting the edit details about the appointment
      startDate: "getStartRepeat" // Gets the currently selected date
    }),
    /**
     * The order option that needs to be shown
     */
    optionsOrder() {
      return this.getRepeat.order;
    },
    /**
     * Outer options are options which don't have more inner layer
     */
    outerOptions() {
      return this.getRepeat.outerOptions;
    },
    /**
     * Specifies if inner or outer is selcted
     */
    innerOrOuter() {
      return this.getRepeat.innerOrOuter;
    },
    /**
     * Selected index is which of the options is currently selected
     */
    selectedIndex() {
      return this.getRepeat.selectedIndex;
    },
    /**
     * Inner options are options ehich have inner layer
     */
    innerOptions() {
      return this.getRepeat.innerOptions;
    },
    /**
     * Gets the current route in the user is at currently
     */
    currentRoute() {
      return this.$router.history.current.name;
    }
  },
  methods: {
    ...mapMutations({
      setRepeat: "setRepeat", // Set repeat details
      setStartRepeat: "setStartRepeat" // Set the currently selected date
    }),
    /**
     * What to do when an option is selected
     */
    optionSelected(value, index) {
      /**
       * If outer option is selected
       *  then select the option and close
       *
       * If inner options are selected
       *  then open the inner tab
       *
       */
      if (value === "outer") {
        // Step 1: Update vuex state
        this.setRepeat({
          selectedIndex: index,
          innerOrOuter: "outer"
        });

        // When never is selected close the panel
        if (index === 0) {
          this.myReturn();
        }
      } else {
        // Step 1: Update vuex state
        this.setRepeat({
          selectedIndex: index,
          innerOrOuter: "inner"
        });
      }
    },
    myReturn() {
      this.done();
    }
  },
  created() {
    // Only setting the start repeat as repeat date when it is not repeat
    if (
      !this.getEdit.isEdit ||
      (this.startDate.dayOfMonth === 0 &&
        this.startDate.month === 0 &&
        this.startDate.year === 0)
    ) {
      this.setStartRepeat(this.getAppDate);
    }
  },
  components: {
    HeaderVue, // Header
    RepeatInner // Repeat inner
  }
};
</script>

<style scoped>
.slide-section-inner-wrapper ul li.my-custom-li span:last-of-type {
  border-bottom: 1px solid #eeeded !important;
}

section {
  overflow: hidden;
}

.slide-section-main {
  overflow: unset;
  top: 108px !important;
}

.slide-section-area-wrapper {
  height: 100%;
  overflow: auto;
}

.slide-section-inner-wrapper {
  margin-bottom: 100px !important;
}

li {
  cursor: pointer;
  list-style: none;
}

.slider-custom-section ul {
  padding-left: 0px;
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.custom-repeat-type-inner {
  width: 96%;
  margin: 0 auto;
  float: none;
  border: 1px solid #ddd !important;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  padding-top: 15px;
}

span.inner-option {
  width: calc(100% - 67px);
  border-bottom: 1px solid #eeeded;
}

li:last-of-type span.inner-option {
  border: none;
}

.my-custom-li {
  height: 32px;
  display: flex;
}

span.check-marker {
  opacity: 0;
  width: 50px;
  float: left;
  padding: 8px 0px;
}

span.check-marker object {
  top: -4px;
  margin-left: 12px;
}

li.active span.check-marker {
  opacity: 1;
}

.remove-top {
  top: 97px !important;
}
</style>
